import './shop-the-look.scss';

// no full swiper-bundle required
import Swiper, { Navigation } from 'swiper';

class ShopTheLook {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-shop-the-look'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$ShopTheLook = element;
        this.$overlay = null;

        this.$slider = this.$ShopTheLook.querySelector('[' + this.settings.initAttr + '="slides"]');
        this.$prev = this.$ShopTheLook.querySelector('[' + this.settings.initAttr + '="prev"]');
        this.$next = this.$ShopTheLook.querySelector('[' + this.settings.initAttr + '="next"]');
    }

    initialize () {
        this.initSlider(this.$slider);
        this.goToHotspot();
        this.setEvents();
    }

    bindClose () {
        const $close = this.$overlay.querySelector('[data-shop-the-look="close"]');
        $close.addEventListener('click', () => {
            this.toggleOverlay();
        });
    }

    initSlider (slider) {
        this.slider = new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 'auto',
            centeredSlides: true,
            speed: 800,
            resistance: true,
            resistanceRatio: 0,
            preloadImages: false,
            watchSlidesVisibility: true,
            lazy: {
                loadPrevNext: true
            },
            navigation: {
                prevEl: this.$prev,
                nextEl: this.$next
            }
        });

        this.slider.on('slideChange', () => {
            this.goToHotspot();
        });
    }

    goToHotspot () {
        const $activeSlide = this.slider.slides[this.slider.activeIndex];
        const hotspotPosition = parseInt($activeSlide.getAttribute('data-position'));
        const windowWidth = window.innerWidth;
        const $hero = this.$ShopTheLook.querySelector('.shop-the-look__hero-image');
        const $heroImage = $hero.querySelector('img');

        // do nothing, when no hotspot data is provided
        if (hotspotPosition === null || hotspotPosition === '' || windowWidth >= 1024) {
            $heroImage.style.transform = '';
            // return false;
        }

        // collect number values
        const imageNaturalWidth = $heroImage.naturalWidth; // original width of image
        const imageWidth = $heroImage.width; // width of image when copped in the html box
        const parentWidth = $hero.offsetWidth;
        const offSetPercent = this.getPercentage(hotspotPosition, imageNaturalWidth); // relative distance from hotspot point to left edge of image
        const offSetPx = imageWidth * offSetPercent / 100;
        let translateValue = 0; // get the distance from left edge of image to hotspot of the cropped image based on the relative (meaning percentage) distance

        // define absolute translation value to center the hotspot on the viewport
        if (imageNaturalWidth > parentWidth) {
            translateValue = -offSetPx + windowWidth / 2;
        }

        // check if translate value is too small or big
        // which would result in pushing the image out of the viewport
        // check for left side
        if (translateValue >= 0) {
            translateValue = 0;
        } else if (translateValue < -imageWidth + windowWidth) {
            // check for right side
            translateValue = -imageWidth + windowWidth;
        }

        $heroImage.style.transform = 'translate3d(' + translateValue + 'px, 0, 0)';
    }

    getPercentage (value, base) {
        return value * 100 / base;
    }

    setEvents () {
        const $fullscreen = this.$ShopTheLook.querySelector('[' + this.settings.initAttr + '="fullscreen"]');

        $fullscreen.addEventListener('click', () => {
            if (this.$overlay === null) {
                this.createOverlay();
            } else {
                this.toggleOverlay();
            }
        });
    }

    createOverlay () {
        const $image = this.$ShopTheLook.querySelector('[' + this.settings.initAttr + '="hero"] img').outerHTML;
        const $overlay = document.createElement('div');
        $overlay.classList.add('shop-the-look__overlay');
        $overlay.innerHTML = $image + '<button class="shop-the-look__close icon-close" data-shop-the-look="close"></button>';

        this.$ShopTheLook.appendChild($overlay);

        this.$overlay = $overlay;

        this.bindClose();

        setTimeout(function () {
            $overlay.classList.add('is--visible');
        });
    }

    toggleOverlay () {
        if (this.$overlay.classList.contains('is--visible')) {
            this.$overlay.classList.remove('is--visible');
        } else {
            this.$overlay.classList.add('is--visible');
        }
    }
}

export { ShopTheLook };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$ShopTheLook = $context.querySelectorAll('[data-shop-the-look="root"]');
        for (let i = 0; i < $$ShopTheLook.length; i++) {
            const $ShopTheLook = new ShopTheLook($$ShopTheLook[i]);
            $ShopTheLook.initialize();
        }
    }
});
